<template>
  <div class="SelectSearchMigracao" v-loading="loadingPage">
    <el-select
      :placeholder="placeholder"
      :disabled="disabled"
      clearable
      v-model="modelData"
      style="width: 100%"
      filterable
      remote
      :remote-method="serch"
      @change="change"
      :loading="loading"
    >
      <el-option
        v-for="item in options"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
        <span style="float: left">{{ item.name }}</span>
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { getListMigracoes } from "@/app/domains/Config/services";
import { isNull } from "lodash";
import { mapGetters } from "vuex";
import { makeErrorFilds } from "@/app/plugins/utils";

export default {
  name: "SelectSearchMigracao",
  props: {
    model: {
      type: [String, Number],
      default: "",
    },
    canACL: {
      type: Boolean,
    },
    isEdit: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "Selecione",
    },
  },
  data() {
    return {
      loadingPage: false,
      loading: false,
      options: [],
      modelData: "",
    };
  },
  computed: {
    ...mapGetters("Auth", ["currentUser"]),
  },
  watch: {
    model: async function (query) {
      if (query !== this.modelData && query !== "" && !isNull(query)) {
        this.options = [];
        this.loadingPage = true;
        await this.serch(query, true);
      }
      if (isNull(query)) {
        this.modelData = "";
      }
    },
  },
  methods: {
    change(val) {
      
      this.$emit(
        "handleObjValue",
        this.options.find((x) => {
          return x.id === val;
        })
      );
      this.$emit("handleValue", val);
    },
    async serch(query, edit = false) {
      this.loading = true;
      try {
        if (edit) {
          let response = await getListMigracoes(query);
          this.options = response.data;
          this.modelData = query;
          this.loadingPage = false;
        } else {
          let response = await getListMigracoes(
            "?name=" + query
          );
          this.options = response.data;
        }
      } catch (e) {
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: "error",
        });
      } finally {
        this.loading = false;
        this.loadingPage = false;
      }
    },
  },
  mounted() {
    if (!this.isEdit) {
      // this.serch('')
    } else {
      this.loadingPage = true;
      this.modelData = this.model;
      this.serch(this.modelData, true);
    }
  },
};
</script>
